import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import isEmail from 'validator/lib/isEmail';
import getRecaptchaToken from '../helpers/getRecaptchaToken';
import AppContext from './context/AppContext';
import { bool } from 'prop-types';

export default function NewsletterConfirmationPage({ isMobile }) {
    const { appContext } = useContext(AppContext);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [isValidRequest, setIsValidRequest] = useState(true);
    const [isVerifying, setIsVerifying] = useState(true);
    const [isVerified, setIsVerified] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const email = searchParams.get('email');
    const code = searchParams.get('code');
    const handleVerificationRequest = useCallback(async () => {
        try {
            if (!email
                || !isEmail(email)
                || !code
                || !code.length) {
                setIsValidRequest(false);
                setIsVerifying(false);
                return;
            }
            setIsVerifying(true);
            setIsVerified(false);
            setErrorMessage(null);
            const params = new URLSearchParams({
                email,
                code,
            }).toString();
            const response = await fetch(new URL(`/api/newsletterSubscriptions/verify?${params}`, process.env.APP_URL), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ token: await getRecaptchaToken(appContext.config.recaptchaSiteKey) }),
            });
            const data = await response.json();
            setIsVerifying(false);
            if (!data.success) {
                if (data.error) {
                    setErrorMessage(data.error);
                }
                setIsVerified(false);
                return;
            }
            setIsVerified(true);
        } catch (e) {
            setIsVerifying(false);
            setErrorMessage(e);
        }
    }, [email, code]);
    useEffect(() => {
        handleVerificationRequest();
    }, [handleVerificationRequest]);
    useEffect(() => {
        const navigateTimeoutFunc = () => {
            navigate('/');
        };
        const navigateTimer = null;
        const NAVIGATE_TIMEOUT_MS = 3000;
        if (isVerified === true) {
            setTimeout(navigateTimeoutFunc, NAVIGATE_TIMEOUT_MS);
        }
        return () => {
            clearTimeout(navigateTimer);
        };
    }, [isVerified]);
    return (<Container
        fluid>
        <div
            className={'page--section mt-4'}>
            {!isValidRequest && (<p>Invalid subscription request.</p>)}
            {isVerifying === true && (<p>Verifying request...</p>)}
            {(isVerifying === false && isVerified === false) && (<p>Request failed.</p>)}
            {isVerified === true && (
                <p
                    style={{ color: 'green' }}>Your email has been successfully registered. Redirecting...</p>
            )}
            {(!isVerifying && errorMessage !== null) && (
                <p
                    style={{ color: 'red' }}>Error: {errorMessage ?? 'Failed.'}</p>
            )}
        </div>
    </Container>);
}

NewsletterConfirmationPage.propTypes = {
    isMobile: bool,
};